define("@ember/runloop/type-tests.ts/bind.test", ["@ember/runloop", "expect-type"], function (_runloop, _expectType) {
  "use strict";

  class Foo {
    test(_foo, _bar, _baz) {
      return 1;
    }
  }
  var foo = new Foo(); // With only function

  (0, _expectType.expectTypeOf)((0, _runloop.bind)((_foo, _bar, _baz) => {
    return 1;
  })).toEqualTypeOf();
  (0, _expectType.expectTypeOf)((0, _runloop.bind)((_foo, _bar, _baz) => {
    return 1;
  }, 1)).toEqualTypeOf();
  (0, _expectType.expectTypeOf)((0, _runloop.bind)((_foo, _bar, _baz) => {
    return 1;
  }, 1, true)).toEqualTypeOf();
  (0, _expectType.expectTypeOf)((0, _runloop.bind)((_foo, _bar, _baz) => {
    return 1;
  }, 1, true, 'baz')).toEqualTypeOf();
  (0, _expectType.expectTypeOf)((0, _runloop.bind)((_foo, _bar, _baz) => {
    return 1;
  }, 1, true, undefined)).toEqualTypeOf();
  (0, _runloop.bind)(_foo => {
    return 1; // @ts-expect-error invalid argument
  }, 'string'); // With target and function

  (0, _expectType.expectTypeOf)((0, _runloop.bind)(foo, function (_foo, _bar, _baz) {
    (0, _expectType.expectTypeOf)(this).toEqualTypeOf();
    return 1;
  })).toEqualTypeOf();
  (0, _expectType.expectTypeOf)((0, _runloop.bind)(foo, function (_foo, _bar, _baz) {
    return 1;
  }, 1)).toEqualTypeOf();
  (0, _expectType.expectTypeOf)((0, _runloop.bind)(foo, function (_foo, _bar, _baz) {
    return 1;
  }, 1, true)).toEqualTypeOf();
  (0, _expectType.expectTypeOf)((0, _runloop.bind)(foo, function (_foo, _bar, _baz) {
    return 1;
  }, 1, true, 'baz')).toEqualTypeOf();
  (0, _expectType.expectTypeOf)((0, _runloop.bind)(foo, function (_foo, _bar, _baz) {
    return 1;
  }, 1, true, undefined)).toEqualTypeOf(); // @ts-expect-error Invalid args

  (0, _runloop.bind)(foo, function (_foo) {
    return 1;
  }, 'string'); // With function string reference

  (0, _expectType.expectTypeOf)((0, _runloop.bind)(foo, 'test')).toEqualTypeOf();
  (0, _expectType.expectTypeOf)((0, _runloop.bind)(foo, 'test', 1)).toEqualTypeOf();
  (0, _expectType.expectTypeOf)((0, _runloop.bind)(foo, 'test', 1, true)).toEqualTypeOf();
  (0, _expectType.expectTypeOf)((0, _runloop.bind)(foo, 'test', 1, true, 'baz')).toEqualTypeOf();
  (0, _expectType.expectTypeOf)((0, _runloop.bind)(foo, 'test', 1, true, undefined)).toEqualTypeOf(); // @ts-expect-error Invalid args

  (0, _runloop.bind)(foo, 'test', 'string');
});